'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { NAVIGATION_URLS } from '@libs/core';
import { logSentryEvent } from '@libs/common-next/utils';
import { SENTRY_CONTEXT } from '../../constants';

export function PageLoadLogger() {
    const pathName = usePathname();

    const pagesSentryContextList = [
        {
            match: (path: string) => path?.startsWith(NAVIGATION_URLS.velocity.cart),
            context: SENTRY_CONTEXT.CART_PAGE_LOADED,
        },
        {
            match: (path: string) => path?.startsWith(NAVIGATION_URLS.velocity.checkoutLogin),
            context: SENTRY_CONTEXT.CHECKOUT_LOGIN_PAGE_LOADED,
        },
        {
            match: (path: string) => path?.startsWith(NAVIGATION_URLS.velocity.checkout),
            context: SENTRY_CONTEXT.CHECKOUT_PAGE_LOADED,
        },
        {
            match: (path: string) => path?.startsWith(NAVIGATION_URLS.velocity.orderConfirmation),
            context: SENTRY_CONTEXT.ORDER_CONFIRMATION_PAGE_LOADED,
        },
    ];

    const sentryContext = pagesSentryContextList.find(rule => rule.match(pathName || ''))?.context;

    useEffect(() => {
        if (sentryContext) {
            logSentryEvent('Page loaded', { sentryContext: sentryContext });
        }
    }, []);

    return null;
}
